const isIos = () => {
    /**
     * Why window.MSStream is excluded?
     We need to exclude window.MSStream as Microsoft injected the word iPhone in IE11’s userAgent in order to try and fool Gmail.
     */
    return  /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};

export default isIos;
